var LocalStorageKeys;
(function (LocalStorageKeys) {
    LocalStorageKeys["PERMISSIONS"] = "permissions";
    LocalStorageKeys["ADMIN_PERMISSIONS"] = "admin_permissions";
    LocalStorageKeys["ADMIN_LAST_URL"] = "admin_last_url";
    LocalStorageKeys["ADMIN_PREV_ROUTE"] = "admin_prev_route";
})(LocalStorageKeys || (LocalStorageKeys = {}));
export default LocalStorageKeys;
